import { Component } from '@angular/core';

@Component({
  selector: 'app-detalhe-projeto-analises-list',
  templateUrl: './detalhe-projeto-analises-list.component.html',
  styleUrls: ['./detalhe-projeto-analises-list.component.scss']
})
export class DetalheProjetoAnalisesListComponent {}